(() => {
  const searchForms = document.querySelectorAll('[data-predictive-search]');
  if (!searchForms.length) return;

  const escapeHtml = (value = '') => String(value)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#039;');

  searchForms.forEach((form) => {
    const input = form.querySelector('[data-predictive-input]');
    const resultsBox = form.querySelector('[data-predictive-results]');
    const endpoint = form.dataset.endpoint || '/search/suggest.json';
    const currency = form.dataset.currency || window.Shopify?.currency?.active || 'USD';
    const locale = document.documentElement.lang || 'en';
    const examples = (form.dataset.placeholders || '').split(',').map((item) => item.trim()).filter(Boolean);

    let requestId = 0;
    let debounceTimer;
    let placeholderTimer;
    let placeholderIndex = 0;

    const money = (value) => {
      if (value === null || value === undefined || value === '') return '';
      const stringValue = String(value);
      const numericValue = Number(stringValue.replace(/[^\d.-]/g, ''));
      if (!Number.isFinite(numericValue)) return stringValue;
      const amount = stringValue.includes('.') ? numericValue : numericValue / 100;
      try {
        return new Intl.NumberFormat(locale, { style: 'currency', currency }).format(amount);
      } catch (_) {
        return amount.toFixed(2);
      }
    };

    const close = () => {
      resultsBox.hidden = true;
      resultsBox.innerHTML = '';
      input.setAttribute('aria-expanded', 'false');
    };

    const open = () => {
      resultsBox.hidden = false;
      input.setAttribute('aria-expanded', 'true');
    };

    const renderEmpty = (query) => {
      resultsBox.innerHTML = `
        <div class="ew-predictive-search__empty">
          <strong>No quick matches</strong>
          <a href="/search?q=${encodeURIComponent(query)}">Search all results for “${escapeHtml(query)}” →</a>
        </div>`;
      open();
    };

    const render = (data, query) => {
      const resources = data?.resources?.results || {};
      const products = Array.isArray(resources.products) ? resources.products : [];
      const collections = Array.isArray(resources.collections) ? resources.collections : [];
      const queries = Array.isArray(resources.queries) ? resources.queries : [];

      if (!products.length && !collections.length && !queries.length) {
        renderEmpty(query);
        return;
      }

      let html = '<div class="ew-predictive-search__inner">';

      if (queries.length) {
        html += '<div class="ew-predictive-search__suggestions"><span class="ew-predictive-search__label">Suggestions</span>';
        queries.slice(0, 4).forEach((item) => {
          const text = item.text || item.styled_text || '';
          html += `<a href="/search?q=${encodeURIComponent(text)}">${escapeHtml(text)}</a>`;
        });
        html += '</div>';
      }

      if (collections.length) {
        html += '<div class="ew-predictive-search__collections"><span class="ew-predictive-search__label">Collections</span>';
        collections.slice(0, 4).forEach((collection) => {
          html += `<a href="${escapeHtml(collection.url || '#')}">${escapeHtml(collection.title || '')}</a>`;
        });
        html += '</div>';
      }

      if (products.length) {
        html += '<div class="ew-predictive-search__products"><span class="ew-predictive-search__label">Products</span>';
        products.slice(0, 6).forEach((product) => {
          const image = product.featured_image?.url || product.image || '';
          const imageHtml = image
            ? `<img src="${escapeHtml(image)}" alt="${escapeHtml(product.featured_image?.alt || product.title || '')}" loading="lazy">`
            : '<span class="ew-predictive-search__image-placeholder"></span>';
          const price = money(product.price);
          html += `
            <a class="ew-predictive-product" href="${escapeHtml(product.url || '#')}">
              <span class="ew-predictive-product__image">${imageHtml}</span>
              <span class="ew-predictive-product__copy">
                <strong>${escapeHtml(product.title || '')}</strong>
                ${price ? `<small data-ew-money="${String(product.price).includes('.') ? Math.round(Number(product.price) * 100) : Number(product.price)}">${escapeHtml(price)}</small>` : ''}
              </span>
            </a>`;
        });
        html += '</div>';
      }

      html += `<a class="ew-predictive-search__view-all" href="/search?q=${encodeURIComponent(query)}">View all results for “${escapeHtml(query)}” →</a>`;
      html += '</div>';
      resultsBox.innerHTML = html;
      open();
    };

    const request = async (query) => {
      const currentRequest = ++requestId;
      try {
        const url = `${endpoint}?q=${encodeURIComponent(query)}&resources[type]=product,collection,query&resources[limit]=6&resources[options][unavailable_products]=last`;
        const response = await fetch(url, { headers: { Accept: 'application/json' } });
        if (!response.ok) throw new Error('Predictive search failed');
        const data = await response.json();
        if (currentRequest !== requestId) return;
        render(data, query);
      } catch (_) {
        if (currentRequest !== requestId) return;
        renderEmpty(query);
      }
    };

    const handleInput = () => {
      const query = input.value.trim();
      window.clearTimeout(debounceTimer);
      if (query.length < 2) {
        close();
        return;
      }
      debounceTimer = window.setTimeout(() => request(query), 160);
    };

    const startPlaceholders = () => {
      if (!examples.length || input.value || document.activeElement === input) return;
      window.clearInterval(placeholderTimer);
      placeholderTimer = window.setInterval(() => {
        if (document.activeElement === input || input.value) return;
        placeholderIndex = (placeholderIndex + 1) % examples.length;
        input.placeholder = `Search for ${examples[placeholderIndex]}`;
      }, 3200);
    };

    input.addEventListener('input', handleInput);
    input.addEventListener('focus', () => {
      window.clearInterval(placeholderTimer);
      if (input.value.trim().length >= 2 && resultsBox.innerHTML) open();
    });
    input.addEventListener('blur', () => {
      window.setTimeout(() => {
        if (!form.contains(document.activeElement)) close();
        startPlaceholders();
      }, 120);
    });

    form.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') {
        close();
        input.blur();
      }
    });

    if (examples.length && !input.value) input.placeholder = `Search for ${examples[0]}`;
    startPlaceholders();
  });
})();
